import React from 'react';
import { compose } from 'recompose';
// import { withStyles } from '@material-ui/core/styles';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

// const styles = {};

const enhance = compose();

// const tableHead = enhance(({ roles }) => {

const CouponTableHead = enhance(() => {
  return (
    <TableHead>
      <TableRow>
        <TableCell />
        <TableCell>No</TableCell>
        <TableCell>Coupon ID</TableCell>
        <TableCell>Menu ID</TableCell>
        <TableCell>Menu name</TableCell>
        <TableCell>Amount</TableCell>
        <TableCell>Tax amount</TableCell>
        <TableCell>Created at</TableCell>
        <TableCell>User email</TableCell>
        <TableCell>Used date</TableCell>
        <TableCell>Used shop name</TableCell>
      </TableRow>
    </TableHead>
  );
});

export default CouponTableHead;
